module.exports = __webpack_public_path__ + "img/bpBJOrange.8b43208b.jpg";